import { JamespotUserApi } from './apis';
import { Network } from './util/network';
import { WindowBrowser } from './window';

export const network = new Network(new WindowBrowser());
const JamespotUserApiInstance = new JamespotUserApi(network);

declare global {
    interface Window {
        JamespotUserApi: JamespotUserApi;
    }
}

window.JamespotUserApi = JamespotUserApiInstance;

export { JamespotUserApiInstance };
export default JamespotUserApiInstance;

export * from './apis';
export * from './types';
export * from './util/';
export * from './window';

export const api = JamespotUserApi;
